import { render, staticRenderFns } from "./AccountTransferReportDialog.vue?vue&type=template&id=238e36d2&"
import script from "./AccountTransferReportDialog.vue?vue&type=script&lang=ts&"
export * from "./AccountTransferReportDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports